export default "__VITE_ASSET__BjjyLSE$__"